import { render } from "./Review.vue?vue&type=template&id=52200b1f&scoped=true"
import script from "./Review.vue?vue&type=script&lang=js"
export * from "./Review.vue?vue&type=script&lang=js"

import "./Review.vue?vue&type=style&index=0&id=52200b1f&lang=css"
import "./Review.vue?vue&type=style&index=1&id=52200b1f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52200b1f"]])

export default __exports__